import React from 'react';

type HeaderProps = {
    gender: string;
}

function GenderToDanish(props: HeaderProps) {
    let returnValue: string = "";
    
    switch (props.gender) {
        case "Male":
            returnValue = "Mand";
            break;
        case "Female":
            returnValue = "Kvinde";
            break;
        default:
            returnValue = "";
    }

    return (<span>{returnValue}&nbsp;</span>);
}

export default GenderToDanish
